import type { PropsWithChildren } from "react";
import React from "react";

import type { TextProps } from "@busbud/horizon";
import { Text } from "@busbud/horizon";

interface ParagraphProps {
  size?: TextProps["size"];
}

export const Paragraph: React.FC<PropsWithChildren<ParagraphProps>> = ({
  children,
  size = { initial: "md", sm: "lg" },
  ...other
}) => {
  return (
    <Text as="p" size={size} className="mb-300" {...other}>
      {children}
    </Text>
  );
};
